import { SvgIcon } from '@material-ui/core';
import { ComponentsProps } from '@material-ui/core/styles/props';
import React from 'react';

import { Checked, Indeterminate } from 'src/Icons';
import { IconTypes } from 'src/types/shared';

export const props: ComponentsProps = {
  MuiCheckbox: {
    checkedIcon: <Checked focusable />,
    disableRipple: true,
    icon: <SvgIcon aria-label={IconTypes.CHECKBOX_EMPTY} fill="none" focusable viewBox="0 0 16 16" />,
    indeterminateIcon: <Indeterminate focusable />,
  },
  MuiRadio: {
    disableRipple: true,
  },
};
